import { Reveal } from "../Reveal";

const stats = [
  { v: "3,400+", l: "Careers elevated" },
  { v: "92%", l: "Interview callback rate" },
  { v: "48h", l: "Average first draft" },
  { v: "4.9/5", l: "Client rating" },
];

export default function Stats() {
  return (
    <section className="bg-cream py-20 border-b border-border" data-testid="stats-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((s, i) => (
          <Reveal key={s.l} delay={i * 0.08}>
            <div className="border-l-2 border-cobalt pl-5">
              <p className="font-display text-5xl lg:text-6xl font-bold text-navy tracking-tight">{s.v}</p>
              <p className="text-slateink mt-2 text-sm">{s.l}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
